// Forms.js

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { List, ListItem, Button, Box, Heading, Text, Center, Spinner } from '@chakra-ui/react';
import { getFormsList } from '../firebase.utils'; // Make sure this is implemented to fetch all forms
import { ViewIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';

const Forms = ({ userToken }) => {
  const [formsList, setFormsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const getRunId = (form) => {
    if (form?.formId) return form.formId;
    if (form?.id) return form.id;
    if (form?.openAiData?.data?.[0]?.run_id) return form.openAiData.data[0].run_id;
    return null;
  };

  useEffect(() => {
    setIsLoading(true);
    const fetchFormsList = async () => {
      const list = await getFormsList(userToken);
      setFormsList(list);
      setIsLoading(false);
    };

    fetchFormsList();
  }, []);

  if (isLoading) {
    return (
      <Center minH="55vh">
        <Box
          bg="white"
          borderWidth="1px"
          borderColor="blue.100"
          borderRadius="2xl"
          p={8}
          boxShadow="sm"
          textAlign="center"
        >
          <Spinner size="lg" mb={4} />
          <Text color="gray.600">{t('loading')}</Text>
        </Box>
      </Center>
    );
  }

  return (
    <Box p={5} maxW="1100px" mx="auto">
      <Heading mb={4}>{t('forms')}</Heading>
      <List spacing={3}>
        {formsList.length ? (
          formsList.map((form) => (
            form?.createFormData?.form_created && getRunId(form) && (
            <ListItem key={getRunId(form)} p={4} borderWidth="1px" borderColor="blue.100" bg="white" borderRadius="xl" display="flex" justifyContent="space-between" alignItems="center" boxShadow="sm">
              <Text fontWeight="semibold">{form.title}</Text>
              <Button leftIcon={<ViewIcon />} colorScheme="blue" onClick={() => navigate(`/form/${getRunId(form)}`)}>
                {t('View')}
              </Button>
            </ListItem>)
          ))
        ) : (
          <Text color="gray.600">{t('no_assessments')}</Text>
        )}
      </List>
    </Box>
  );
};

export default Forms;